import styled from '@emotion/styled';

export const Body = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[16],
}));

export const ContactRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[8],
  minWidth: 0,
}));

export const ContactAvatarImg = styled('img')(({ theme }) => ({
  width: 32,
  height: 32,
  borderRadius: theme.radius.full,
  objectFit: 'cover',
  flexShrink: 0,
}));

export const Divider = styled('div')(({ theme }) => ({
  height: 1,
  backgroundColor: theme.colors.border.default,
}));

export const CategoryGroup = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[8],
}));

export const BadgeRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing[4],
}));
